<template>
    <div class="widgetPanel favorite collapsed">
        <div class="glyphIcon icon-widgetCollapse" title="Collapse the Widget Panel">
        </div>
        <div class="heading current icon-favorite added" :title="langList.myFav" @click="changeFavorite">
            <div class="text">{{ langList.myFav }}</div>
        </div>
        <div class="contentArea"></div>
        <div class="bottomArea"></div>
    </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'
import EventBus from '@/vue/events/event-bus'
import sportMatchCount from '@/vue/mixins/sportMatchCount'

export default {
    mixins: [ sportMatchCount ],
    components: {
    },
    computed: {
      ...mapGetters([
          'langList',
          'showFavEvents',
          'account',
      ]),
      showFavEvents: {
        get () {
          return this.$store.getters.showFavEvents
        },
        set (value) {
          if(!this.account.previewFlag){
            // this.$store.commit('SPORT_SHOW_FAV_EVENTS', value)
            EventBus.$emit('refreshOdd', true)
            this.$store.dispatch('getSportOdds',{
              showfavorite: value,
              callback: ((res) => {
              //   this.refreshTimer()
                this.refreshScroll()
              }).bind(this)
            })
          }
        }
      },
    },
    data() {
      return {
        timerSeconds: 180,
      }
    },
    methods: {
      changeFavorite() {
        this.showFavEvents = true
        this.$store.commit('EVENTLIST', [])
        EventBus.$emit('viewAccountSetting', false)
        this.$store.commit("GAMEBANNER_SELECTED", false);
        this.$store.commit('SELECTED_ALLBET', false)
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
        this.$store.commit('SELECTED_MATCHALLBET', false)
        this.resetSportBettype()
        EventBus.$emit('refreshOdd', true );
        EventBus.$emit('pageChange', this.$store.getters.market.favMarket.key );
      },
      refreshTimer () {
        this.clearTimer()
        this.timerSeconds = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 180
        this.startTimer()
      },
      refreshScroll() {
        var main = document.getElementById('right_div');
        var sportTableWidth = $('.tableContent').outerWidth();
        if(main) {
          var maxTop = main.parentNode.parentNode.scrollHeight-main.offsetHeight;

          main.parentNode.parentNode.onscroll = function() {
             main.style.top = Math.min(this.scrollTop + 39) + "px";
             main.style.left = sportTableWidth + "px";
          }
        }
      },
    },
    mounted () {

    },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/myFavorite.vue